import computedCustomer from './computed/customer'
import dataCustomer from './data/customer'
import methodsCustomer from './methods/customer'

export default {
  data () {
    return dataCustomer
  },
  computed: computedCustomer,
  methods: methodsCustomer
}
